export function rect(ctx, position, width, height, colour) {
    ctx.beginPath();
    ctx.rect(position.x, position.y, width, height);
    ctx.fillStyle = colour;
    ctx.fill();
    ctx.closePath();
}
export function circle(ctx, position, radius, colour) {
    ctx.beginPath();
    ctx.arc(position.x, position.y, radius, 0, Math.PI * 2);
    ctx.fillStyle = colour;
    ctx.fill();
    ctx.closePath();
}
export function line(ctx, start, end, colour) {
    ctx.beginPath();
    ctx.moveTo(start.x, start.y);
    ctx.lineTo(end.x, end.y);
    ctx.strokeStyle = colour;
    ctx.stroke();
    ctx.closePath();
}
export function arrow(ctx, start, end, arrowSize, colour, arrowPlacement = 0) {
    ctx.beginPath();
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const angle = Math.atan2(dy, dx);
    let mid = end.clone.sub(end.clone.sub(start).scale(arrowPlacement));
    ctx.moveTo(start.x, start.y);
    ctx.lineTo(end.x, end.y);
    ctx.moveTo(mid.x, mid.y);
    ctx.lineTo(mid.x - arrowSize * Math.cos(angle - Math.PI / 6), mid.y - arrowSize * Math.sin(angle - Math.PI / 6));
    ctx.moveTo(mid.x, mid.y);
    ctx.lineTo(mid.x - arrowSize * Math.cos(angle + Math.PI / 6), mid.y - arrowSize * Math.sin(angle + Math.PI / 6));
    ctx.strokeStyle = colour;
    ctx.stroke();
    ctx.closePath();
}
